import { cn } from 'cn';

import { KpiDeliveryNotesAssigned } from './KpiDeliveryNotesAssigned';
import { KpiDeliveryNotesReceived } from './KpiDeliveryNotesReceived';
import { KpiDeliveryNotesSigned } from './KpiDeliveryNotesSigned';

/**
 * DeliveryNoteKpis
 *
 * Displays all delivery note-related KPIs (received, assigned, and signed delivery notes).
 */
export const DeliveryNoteKpis = ({ className, style }: ComponentStyling) => {
  return (
    <div
      className={cn(
        'grid grid-cols-[repeat(auto-fit,minmax(0,1fr))] gap-4',
        className,
      )}
      style={style}
    >
      <KpiDeliveryNotesReceived />
      <KpiDeliveryNotesAssigned />
      <KpiDeliveryNotesSigned />
    </div>
  );
};
